<template>
  <div class="completion-modal-content">
    <div v-html="htmlContent" class="html-content"></div>
  </div>
</template>

<script>
export default {
  name: 'DesignatedPositionCompletionModal',
  props: {
    payload: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    htmlContent () {
      if (this.payload && this.payload.props && this.payload.props.html_content) {
        return this.payload.props.html_content
      }
      if (this.payload && this.payload.html_content) {
        return this.payload.html_content
      }
      return ''
    }
  }
}
</script>

<style scoped>
.completion-modal-content {
  padding: 1rem;
  text-align: center;
}

.html-content {
  min-height: 200px;
}

</style>
